import React from 'react'
import { Box, Divider, Typography, Skeleton } from '@mui/material'

import { AppLinearProgress, AppRetailerBlock } from '@components'


export default function AppReportSearchesSitesModalBlock({ isLoading, sitesData }) {

	if (isLoading) return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 1.5, width: '50%' }}>
		<Skeleton variant="rectangular" height={60} width="100%"/>
		<Skeleton variant="rectangular" height={270} width="100%"/>
	</Box>

	const { sitesInfo, completedPercentage, totalPercentage } = sitesData

	return <Box sx={{ width: '50%' }}>
		<Typography variant="subtitle1">
			Searches by Web
		</Typography>

		<AppLinearProgress actual={completedPercentage} total={totalPercentage} highlighted/>

		<Divider sx={{ my: 3 }}/>
		<Box sx={{ maxHeight: '30vh', overflowY: 'auto', p: 1 }}>
			{sitesInfo?.map(({ name, market, current, icon, total }, idx) => <Box key={idx} sx={{
				display: 'flex',
				width: 1,
				mb: .5,
				gap: 1,
			}}>
				<AppRetailerBlock icon={icon} retailer={name} country={market} sx={{ textWrap: 'nowrap', minWidth: 120 }}/>
				<AppLinearProgress actual={current} total={total} color="info"/>
			</Box>)}
		</Box>
	</Box>
}